angular.module('nv.singleStudent').component('studentCreditsPanel', {
  template: require('./student-credits-panel.html'),
  bindings: {
    student: '<',
    school: '<',
  },
  controller: 'StudentCreditsPanelCtrl',
});
